import React, { Component } from 'react';
import SwitchComponent from './SwitchComponent';
import { Typography } from '@material-ui/core';
import * as ValidationUtils from '../../utils/ValidationUtils';

export default class OfertaConsumoComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      seleccionado: true,
    };
  }

  onSelectionChange = (value) => {
    if (this.props.onSelectionChange) {
      this.props.onSelectionChange(value);
    }
  };

  render() {
    let seleccionable;
    if (this.props.eliminable) {
      seleccionable = <SwitchComponent checked={this.props.producto.selected} onChange={this.onSelectionChange} />;
    }
    return (
      <div className="contenedorCreditoSwitch">
        <div className="checkTitulo">
          <div>
            <h3>{this.props.producto.nombreProducto}</h3>
          </div>
          {seleccionable}
        </div>
        <div className="Ofertainfo">
          <Typography>Monto total del crédito</Typography>
          <Typography>$ {ValidationUtils.formatMontoWithZero(this.props.producto.montoTotal)}</Typography>
        </div>
        <div className="Ofertainfo">
          <Typography>Monto consolidación deuda</Typography>
          <Typography>$ {ValidationUtils.formatMontoWithZero(this.props.producto.pagoDeuda)}</Typography>
        </div>
        <div className="Ofertainfo">
          <Typography>Monto libre disposición</Typography>
          <Typography>$ {ValidationUtils.formatMontoWithZero(this.props.producto.libreDisposicion)}</Typography>
        </div>
        <div className="Ofertainfo">
          <Typography>Plazo</Typography>
          <Typography>{this.props.producto.plazoSubscripcion} meses</Typography>
        </div>
        <div className="Ofertainfo">
          <Typography>Tasa</Typography>
          <Typography>{ValidationUtils.formatTasa(this.props.producto.tasaVigente)} %</Typography>
        </div>
        <div className="Ofertainfo">
          <Typography>CAE</Typography>
          <Typography>{ValidationUtils.formatTasa(this.props.producto.caeVigente)} %</Typography>
        </div>
        <div className="Ofertainfo">
          <Typography>Cuota</Typography>
          <Typography>$ {ValidationUtils.formatMontoWithZero(this.props.producto.cuotaMensualVigente)}</Typography>
        </div>
      </div>
    );
  }
}

OfertaConsumoComponent.defaultProps = {
  producto: {},
};
